import { CARD_DARK } from '../constants';

export function SectionFade() {
  return <div className='pointer-events-none absolute inset-0' style={{ background: `linear-gradient(180deg, transparent, ${CARD_DARK} 20%, ${CARD_DARK} 80%, transparent)` }} aria-hidden='true' />;
}
